import React from 'react';
import Home from "../../components/home"

function DocumentIndex() {
    return(<Home/>)
}

export default DocumentIndex;